import React from 'react';
import Header from '../components/Header';
import Footer from '../components/Footer';
import { Swiper, SwiperSlide } from 'swiper/react';
import 'swiper/css';
import 'swiper/css/free-mode';
import { FreeMode } from 'swiper/modules';

const Andon = () => {
  return (
    <div id="main-wrapper">
      <Header />

      <div id="content" role="main">
        {/* Hero Section */}
        <section
          className="hero-wrap"
          style={{
            position: 'relative',
            overflow: 'hidden',
            minHeight: '60vh',
            display: 'flex',
            alignItems: 'center',
            backgroundImage: "url('/images/projects/dasha.png')",
            backgroundSize: 'cover',
            backgroundPosition: 'center',
            backgroundRepeat: 'no-repeat',
          }}
        >
          <div className="container" style={{ position: 'relative', zIndex: 2, paddingTop: '70px' }}>
            <div className="row">
              <div className="col-12 text-center text-white">
                <h1 className="text-16 font-weight-600 mb-3 text-white">Andon</h1>
                <p className="lead text-white-100 mb-0">
                 Real-Time Production Alerts for Smarter Manufacturing
                </p>
              </div>
            </div>
          </div>
          <div style={{ position: 'absolute', top: 0, left: 0, width: '100%', height: '100%', background: 'rgba(0,0,0,0.5)', zIndex: 1 }}></div>
        </section>

        {/* Blog Intro */}
        <section className="py-5 bg-white text-dark">
          <div className="container">
            <div className="row align-items-center mb-5 g-4 flex-column-reverse flex-md-row"> 
              <div className="col-md-6 mb-4 mb-md-0"> 
                <img 
                  src="/images/projects/and.png" 
                  alt="Robots on Factory Floor" 
                  className="img-fluid rounded-4 shadow-lg"
                  style={{ height: '350px', objectFit: 'cover', width: '100%' }}
                />
              </div>
              <div className="col-md-6">
                <h2 className="fw-bold mb-3">Andon: Instant Visibility, Faster Decisions, Smarter Manufacturing</h2>
                <p className="text-black" style={{ fontSize: "1rem" }}>
                 Andon is a visual and digital alert system designed to instantly notify teams about issues on the production line. By enabling real-time visibility of equipment malfunctions, quality concerns, and workflow interruptions, Andon empowers manufacturers to respond faster, minimize downtime, and improve overall operational efficiency.
                </p>
              </div>
            </div>
          </div>
        </section>

        {/* What is RovoConnect */}
        <section className="py-5 bg-light text-dark">
          <div className="container">
            <div className="row mb-4">
              <div className="col-lg-10 mx-auto text-center">
                <h2 className="fw-bold mb-3">What is Andon?</h2>
                <p className="text-black" style={{ fontSize: "1rem" }}>
                Andon is a manufacturing management tool that signals problems in real time, using lights, alarms, or digital dashboards. It connects operators, maintenance teams, and managers, creating a responsive production environment.
                </p>
              </div>
            </div>

            <div className="row g-4">
              {[
                { title: "Real-Time Alerts", text: "Instantly informs operators and supervisors about line stoppages or production anomalies.", icon: "bi bi-display", img: "/images/projects/rta.png" },
                { title: "Visual Indicators", text: "Uses lights, screens, or dashboards for immediate problem recognition.", icon: "bi bi-activity", img: "/images/projects/vis.png" },
                { title: "Operator Engagement", text: "Encourages frontline employees to report issues proactively.", icon: "bi bi-robot", img: "/images/projects/ope.png" },
                { title: "Data-Driven Insights", text: "Tracks recurring problems to help identify patterns and optimize processes.", icon: "bi bi-clock", img: "/images/projects/datar.png" },
              ].map((feature, idx) => (
                <div className="col-12 col-md-6 col-lg-6 mb-4" key={idx}>
                  <div className="card h-100 border-0 shadow-lg rounded-4 overflow-hidden">
                    <img 
                      src={feature.img} 
                      alt={feature.title} 
                      className="card-img-top"
                      style={{ height: '250px', objectFit: 'cover', width: '100%' }} 
                    />
                    <div className="card-body">
                      <div className="mb-2 text-primary">
                        <i className={`${feature.icon} fs-2`}></i>
                      </div>
                      <h5 className="fw-bold mb-3">{feature.title}</h5>
                      <p className="text-muted mb-0">{feature.text}</p>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </section>

        {/* Business Impact */}
        <section className="py-5 bg-light text-dark">
          <div className="container">
            <div className="row align-items-center g-4 flex-column-reverse flex-md-row">
              <div className="col-md-6">
                <h2 className="fw-bold mb-4">Business Impact</h2>
                <p className="text-black" style={{ fontSize: "1.25rem" }}>
                  Andon significantly reduces production downtime, improves product quality, and enhances team responsiveness. By addressing issues the moment they occur, manufacturers can avoid costly delays, maximize throughput, and maintain high operational efficiency. Over time, Andon contributes to continuous improvement initiatives, boosting profitability and customer satisfaction.
                </p>
                {/* <ul className="list-unstyled text-muted fs-20">
                  <li className="mb-2"> Reduce unplanned downtime and maintenance costs</li>
                  <li className="mb-2"> Improve machine performance and utilization</li>
                  <li className="mb-2"> Enhance product quality and minimize defects</li>
                  <li className="mb-2"> Optimize production throughput and energy efficiency</li>
                  <li className="mb-2"> Support informed, data-driven operational decisions</li>
                </ul> */}
              </div>

              <div className="col-md-6">
                <img
                  src="/images/projects/bmp.png"
                  alt="Business Impact"
                  className="img-fluid rounded-4 shadow-lg"
                  style={{ height: '400px', objectFit: 'cover', width: '100%' }}
                />
              </div>
            </div>
          </div>
        </section>

        {/* Key Features & Capabilities */}
        <section className="py-5 bg-white text-dark">
          <div className="container">
            <div className="row mb-4">
              <div className="col-lg-10 mx-auto text-center">
                <h2 className="fw-bold mb-3">Key Features & Capabilities</h2>
                <p className="text-muted mb-5">
              Empowering Your Production Floor with Smart Alerts and Insights
                </p>
              </div>
            </div>

            {/* Horizontal scrollable container */}
            <div
              className="d-flex flex-row flex-nowrap"
              style={{
                gap: "1rem",
                paddingBottom: "1rem",
                overflowX: "auto",
                scrollbarWidth: "none",
                msOverflowStyle: "none",
              }}
              onWheel={(e) => {
                e.currentTarget.scrollLeft += e.deltaY;
              }}
            >
              <style>
                {`
                  div::-webkit-scrollbar {
                    display: none;
                  }
                  @media (max-width: 768px) {
                    .card {
                      min-width: 250px !important;
                      height: auto !important;
                    }
                    .card img {
                      height: 180px !important;
                    }
                  }
                `}
              </style>

              {[
                { title: "Instant Notifications", text: "Alerts staff immediately when a problem occurs.", icon: "bi bi-collection", img: "/images/projects/inoty.png" },
                { title: "Integration with MES/ERP", text: "Connects seamlessly with existing manufacturing systems.", icon: "bi bi-speedometer2", img: "/images/projects/intems.png" },
                { title: "Customizable Alerts", text: "Tailor notifications by severity, department, or machine.", icon: "bi bi-bar-chart", img: "/images/projects/cusa.png" },
                { title: "Dashboard Analytics", text: "Provides visual reports for downtime, trends, and root causes.", icon: "bi bi-controller", img: "/images/projects/dasha.png" },
                 { title: "Multi-Channel Alerts", text: "Notifies via lights, sounds, mobile apps, or digital screens.", icon: "bi bi-layers", img: "/images/projects/multc.png" },
                // { title: "Decision-Making", text: "Make smarter decisions using real-time insights from robots and PLCs.", icon: "bi bi-layers", img: "/images/projects/rovovision.png" },
              ].map((feature, idx) => (
                <div
                  key={idx}
                  className="card flex-shrink-0 border-0 shadow-lg rounded-4 overflow-hidden"
                  style={{ width: "300px" }}
                >
                  <img
                    src={feature.img}
                    alt={feature.title}
                    className="card-img-top"
                    style={{ height: "200px", objectFit: "cover" }}
                  />
                  <div className="card-body">
                    <div className="mb-2 text-primary">
                      <i className={`${feature.icon} fs-2`}></i>
                    </div>
                    <h5 className="fw-bold mb-2">{feature.title}</h5>
                    <p className="text-muted mb-0">{feature.text}</p>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </section>

        {/* Why Choose RovoConnect */}
        <section className="py-5 bg-light text-dark">
          <div className="container">
            <div className="row align-items-center g-4 flex-column-reverse flex-md-row">
              <div className="col-md-6">
                <img
                  src="/images/projects/and.png"
                  alt="Why Choose RovoConnect"
                  className="img-fluid rounded-4 shadow-lg mb-4"
                  style={{ height: '400px', objectFit: 'cover', width: '100%' }}
                />
              </div>
              <div className="col-md-6">
                <h2 className="fw-bold mb-4">Why Choose Andon?</h2>
                <p className="text-muted mb-4">Andon streamlines manufacturing operations by providing immediate alerts when issues arise. It empowers teams to respond quickly, preventing prolonged downtime and reducing production errors. By giving operators and managers real-time visibility into line performance, Andon enhances efficiency, ensures consistent product quality, and fosters a culture of proactive problem-solving. In short, it turns production challenges into opportunities for continuous improvement and operational excellence.
                </p>
                <ul className="list-unstyled text-muted fs-6">
                  <li className="mb-3"><strong>Faster Response Times:</strong> Reduce production delays by acting immediately on alerts.</li>
                  <li className="mb-3"><strong>Improved Quality Control:</strong>Catch issues before they affect the final product.</li>
                  <li className="mb-3"><strong>Employee Empowerment:</strong>Operators become active participants in problem-solving.</li>
                  <li className="mb-3"><strong>Enhanced Productivity:</strong> Minimize idle time and optimize machine utilization.</li>
                   <li className="mb-3"><strong>Continuous Improvement:</strong> Data insights help prevent recurring issues and drive operational excellence.</li>
                  
                </ul>
              </div>
            </div>
          </div>
        </section>

        {/* Conclusion & CTA */}
        <section className="py-5 bg-dark text-white text-center">
          <div className="container">
            <p className="lead mb-4 mx-auto" style={{ maxWidth: '800px' }}>
          Andon transforms manufacturing floors into intelligent, responsive, and efficient environments. By providing real-time alerts, actionable insights, and empowering employees, it not only minimizes downtime but also enhances overall productivity, quality, and profitability. For any manufacturer aiming to stay competitive, Andon is an indispensable tool for operational excellence.
            </p>
            <a href="/contact" className="btn btn-primary btn-lg rounded-pill px-5">Inquire About Partnership</a>
          </div>
        </section>
      </div>

      <Footer />
    </div>
  );
};

export default Andon;
